import {
  KanalType,
  KundgruppType,
  LamnaOverType,
} from "@/composables/KundserviceAppApiClient";
import type { Option, OptionGroup } from "@/types/form";
import {
  kanalTypeToOption,
  kundgruppTypeToOption,
  lamnaOverTypeToOption,
} from "@/common/constants";

export const AnstalldKanalOptions: Option[] = [
  KanalType.Telefon,
  KanalType.Chat,
  KanalType.Epost,
  KanalType.InloggadPaAvtalatSe,
].map(kanalTypeToOption);

export const AnstalldKundgruppOptions: Option[] = [
  KundgruppType.Arbetare,
  KundgruppType.Tjansteman,
].map(kundgruppTypeToOption);

export const AnstalldLamnaOverTillOptionGroups: OptionGroup[] = [
  {
    label: "Internt",
    options: [
      lamnaOverTypeToOption(LamnaOverType.Kundservice),
      lamnaOverTypeToOption(LamnaOverType.Collectum),
    ],
  },
  {
    label: "Andra tjänster",
    options: [
      lamnaOverTypeToOption(LamnaOverType.Radgivningstjansten),
      lamnaOverTypeToOption(LamnaOverType.SupportForInformatorer),
      lamnaOverTypeToOption(LamnaOverType.Webbgruppen),
      lamnaOverTypeToOption(LamnaOverType.Klagomal),
      lamnaOverTypeToOption(LamnaOverType.Legal),
    ],
  },
  {
    label: "Externt",
    options: [
      lamnaOverTypeToOption(LamnaOverType.Fora),
      lamnaOverTypeToOption(LamnaOverType.Alecta),
      lamnaOverTypeToOption(LamnaOverType.AfaForsakring),
    ],
  },
];
